module.exports = __webpack_public_path__ + "img/licenses.f726f92c.png";